<template>
  <div role="combobox"
       class="input-group input-group--focused input-group--dirty input-group--text-field input-group--select primary--text">
    <label>{{ label }}</label>
    <div class="input-group__input">
      <div class="input-group__selections">
        <date-picker
          :clearable="false"
          format="YYYY-MM-DD"
          v-model="dateValue"
          @change="triggerUpdate"
          :not-before="disableBefore"
          :not-after="disableAfter"
          lang="en"
        ></date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  name: "DashDatePicker",
  data() {
    return {
      dateValue: ""
    };
  },
  props: ['rangeControl', 'label', 'fullDate', 'identifier'],
  computed: {
    date: {
      get: function() {
        return this.dateValue;
      },
      set: function(value) {
        this.dateValue = value;
      }
    },
    disableBefore() {
      if (typeof this.fullDate.from === "string" && this.identifier === 'dateTo') {
        return this.fullDate.from;
      }

      return '';
    },
    disableAfter() {
      if (typeof this.fullDate.to === "string" && this.identifier === 'dateFrom') {
        return this.fullDate.to;
      }

      return '';
    }
  },
  components: { DatePicker },
  methods: {
    triggerUpdate() {
      const sDate = new Date(this.dateValue);
      sDate.setDate(sDate.getDate() + 1);
      const dateVal = sDate.toISOString().split('T')[0];

      this.$emit('date-picked', dateVal);
    }
  },
  watch: {
    rangeControl: function(val) {
      this.dateValue = val;
    }
  },
  created() {
    this.dateValue = this.rangeControl;
  }
}
</script>

<style scoped>
span {
  float: left;
}
</style>
